import angular from 'angular';

import customSelectUrl from './customSelect.html';

const BORDER_WIDTH = 1;
const DROPDOWN_MIN_WIDTH = 160;

class CustomSelectController {
  constructor(Authentication, $scope, $element, $document, $window, $timeout) {
    'ngInject';

    Object.assign(this, { Authentication, $scope, $element, $document, $window, $timeout });
  }

  $onInit() {
    const _isFocusable = (element) => {
      if (element.hasAttribute('tabindex')) {
        return element.tabIndex >= 0;
      }

      return /^(INPUT|TEXTAREA)$/.test(element.tagName);
    };

    const onFocusIn = ({ target }) => {
      if (target === this.$toggle[0] && !this.disabled) {
        this.$scope.$evalAsync(() => {
          this.dropdownOpened = true;
        });
      } else if (_isFocusable(target) && !angular.element(target).closest(this.$element).length) {
        this.$scope.$evalAsync(() => {
          this.dropdownOpened = false;
        });
      }
    };

    this.$window.addEventListener('focusin', onFocusIn);

    this.$scope.$on('$destroy', () => {
      this.$window.removeEventListener('focusin', onFocusIn);
    });

    this.$scope.$watch('ctrl.selectedValue', () => {
      delete this._selectedObj;
    });

    this.$scope.$watch('ctrl.dropdownOpened', (isOpened) => {
      this.$element[isOpened ? 'addClass' : 'removeClass']('active');
    });
  }

  $doCheck() {
    if (this.ngModel) {
      this.selectedValue = this.ngModel.$viewValue;
    }

    if (this.uibDropdownCtrl) {
      const elementOffsetWidth = this.$element[0].offsetWidth;

      if (elementOffsetWidth !== this.elementPreviousOffsetWidth) {
        const minWidth = Math.max(
          DROPDOWN_MIN_WIDTH,
          this.$element[0].offsetWidth - 2 * BORDER_WIDTH
        );
        this.uibDropdownCtrl.dropdownMenu.css('min-width', `${minWidth}px`);

        this.elementPreviousOffsetWidth = elementOffsetWidth;
      }
    }
  }

  $postLink() {
    if (this.uibDropdownCtrl && this.dropdownHeight) {
      this.uibDropdownCtrl.dropdownMenu.css('max-height', `${this.dropdownHeight}px`);
    }

    this.$toggle = this.$element.find('[uib-dropdown-toggle]');
    this.$toggle.on('mousedown', (e) => e.preventDefault());
  }

  $onChanges() {
    delete this._selectedObj;
  }

  select(value) {
    if (this.premiumOptions?.includes(value) && !this.Authentication.user.org.isPremium) {
      return;
    }

    delete this._selectedObj;

    if (value === this.selectedValue) {
      return;
    }

    this.selectedValue = value;

    if (this.ngModel) {
      this.ngModel.$setViewValue(value);
    } else if (this.form) {
      this.form.$setDirty();
    }

    if (typeof this.selectCallback === 'function') {
      this.selectCallback({ value });
    }
  }

  get selectedObj() {
    if (!('_selectedObj' in this)) {
      this._selectedObj = this.getSelectedObject();
    }

    return this._selectedObj;
  }

  getSelectedObject() {
    let match = {};
    const f = (option) => {
      if (option.submenu) {
        option.submenu.forEach(f);
      } else if (option.value === this.selectedValue) {
        match = option;
      }
    };

    this.options?.forEach(f);

    return match;
  }

  focused() {
    this.dropdownOpened = true;
  }

  get scrollToValue() {
    const currentLabel = this.selectedObj.label || '';

    if (this.scrolledBottom && !currentLabel) {
      const lastOption = this.options[this.options.length - 1];
      return lastOption?.label || '';
    }

    return currentLabel;
  }
}

export default {
  templateUrl: customSelectUrl,
  controller: CustomSelectController,
  controllerAs: 'ctrl',
  require: {
    form: '?^form',
    ngModel: '?ngModel',
  },
  transclude: {
    toggle: '?customToggle',
    options: '?customOptions',
  },
  bindings: {
    options: '<?',
    premiumOptions: '<?',
    selectedValue: '=?',
    selectCallback: '&?',
    preventClose: '=?',
    disabled: '<?ngDisabled',
    placeholder: '<?',
    dropdownHeight: '@?',
    enableScrollToSelected: '<?',
    appendToBody: '<',
    includeClear: '<?',
    dropdownOpened: '=?',
    noMaxHeight: '<?',
    submenuPosition: '<?',
    customToggleOnly: '<?',
    scrollableSmall: '<?',
    decreseZIndex: '<?',
    scrolledBottom: '<?',
  },
};
